import React, { useEffect, useState } from "react";

const NumberInput = ({ defaultValue, value, afterChange, ...rest }) => {
  const ref = React.useRef();
  const [stateValue, setStateValue] = useState(defaultValue ?? value ?? "");
  const decimalDelimiter = (document.body.getAttribute("data-number-format") || '1 000.00').split(/[\-\d]+/)[2];

  useEffect(() => {
    if (typeof value != "undefined" && value !== stateValue) {
      setStateValue(value ?? "");
    }
  }, [value]);
  const handleChange = (e) => {
    // Allow negative numbers, and decmial
    let parsedValue;
    if(e.target.value == '' || e.target.value == "-"){
      parsedValue = e.target.value;
    }else{
      // eg '1.'
      if(e.target.value.split(decimalDelimiter).length ==2 && e.target.value.slice(-1) == decimalDelimiter){
        parsedValue = parseFloat(e.target.value) + decimalDelimiter
      }
      // eg '1.0'
      else if(e.target.value.split(decimalDelimiter).length ==2 && parseFloat(e.target.value.split(decimalDelimiter)[1]) == 0){
        parsedValue = parseFloat(e.target.value) + decimalDelimiter + e.target.value.split(decimalDelimiter)[1]
      }
      else{
        parsedValue = parseFloat(e.target.value.replace(decimalDelimiter, '.')) 
      }
    }

    if (parsedValue != "-" && parsedValue.toString().slice(-1) != decimalDelimiter && isNaN(parsedValue)) return; // Show error?
    
    setStateValue(parsedValue);
    if (afterChange) {
      afterChange(parsedValue);
    }
  };

  return <input ref={ref} type="text" className="form-control" value={stateValue} onChange={handleChange} {...rest} />;
};

export default NumberInput;
